import { render, staticRenderFns } from "./AddressBookAddAddress.vue?vue&type=template&id=4a39a9b3&scoped=true&"
import script from "./AddressBookAddAddress.vue?vue&type=script&lang=js&"
export * from "./AddressBookAddAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a39a9b3",
  null
  
)

export default component.exports